import { format } from 'date-fns'

import type { PatientDietListItem } from '@/services/dietsService'

import type { ActiveDietItem, DietStatusLabel } from './types'

export function getDietStatusLabel(status: number): DietStatusLabel {
  if (status === 1) return 'Szkic'
  if (status === 3) return 'Archiwalny'
  return 'Gotowy'
}

export function formatDietDateRange(start: number | null, end: number | null): string | null {
  if (!start || !end) return null
  return `${format(new Date(start * 1000), 'dd.MM.yyyy')} - ${format(new Date(end * 1000), 'dd.MM.yyyy')}`
}

export function toActiveDietItem(item: PatientDietListItem, activeId: number): ActiveDietItem {
  return {
    dateRange: formatDietDateRange(item.start_date, item.end_date),
    id: item.id,
    isActive: item.id === activeId,
    name: item.name,
    status: getDietStatusLabel(item.status),
  }
}
